import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {COLORS} from '../../../../constants/colors';
import {Icon} from '../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../atoms/Icon/IconName';
import {UnstyledLink} from '../../../atoms/UnstyledLink/UnstyledLink';
import {HelpCenterCard} from './HelpCenterCard';

interface HelpCenterNavigationCardProps {
  title: string;
  iconUrl?: string;
  url?: string;
  onClick?: () => void;
  dataTestId?: string;
}

const ArrowIcon = styled(Icon)`
  margin-left: 14px;
  fill: ${COLORS.Grey2};
`;

/**
 * @deprecated This component is deprecated because it violates best practices defined in the @aboutyou/ui-components.
 * Do not take inspiration from this component for new implementations.
 */
export const HelpCenterNavigationCard: FC<
  React.PropsWithChildren<HelpCenterNavigationCardProps>
> = ({title, iconUrl, url = '', children, dataTestId, onClick}) => {
  return (
    <UnstyledLink to={url} onClick={onClick}>
      <HelpCenterCard
        title={title}
        iconUrl={iconUrl}
        arrowIcon={<ArrowIcon size="XS" asset={GenericIconName.ArrowRight} />}
        dataTestId={dataTestId}
      >
        {children}
      </HelpCenterCard>
    </UnstyledLink>
  );
};
